import { RequestKind } from '@sb/library/base';
import { DisplayItemCollection, LanguageDisplayItem, LocaleInfoDisplayItem, TimeZoneInfoDisplayItem, TimeZoneSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace LocalizationRoutes {
    export const GetAll = ApiRoute.Define({
        URL: `locales/`,
        Kind: RequestKind.Get,
        ResultType: Array<LocaleInfoDisplayItem>
    });

    export namespace TimeZones {
        export const GetAll = ApiRoute.Define({
            URL: 'timezones/',
            Kind: RequestKind.Get,
            ResultType: Array<TimeZoneInfoDisplayItem>
        });

        export const Search = ApiRoute.Define({
            URL: 'search/timezone',
            Kind: RequestKind.Post,
            BodyType: TimeZoneSearchOptions,
            ResultType: TimeZoneInfoDisplayItem
        });
    }

    export namespace Languages {
        export const GetAll = ApiRoute.Define({
            URL: 'languages/',
            Kind: RequestKind.Get,
            ResultType: Array<LanguageDisplayItem>
        });
    }
}
